import React, { useState, Dispatch } from 'react';
import { myProfileService } from '@app/services';
import { TwoFactorOtp } from '@app/modules/mfaToken/components';
import { loginForms } from '@app/enums';
import { useTypedTranslation } from '@app/hooks';
import { MfaTestSuccess } from './';

export const onSubmitOtp = (setIsLoggingIn: Dispatch<boolean>, setIsSuccess: Dispatch<boolean>) => (
    otpCode: string,
    setIsError: React.Dispatch<boolean>
) => (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoggingIn(true);
    return myProfileService
        .testOtp(otpCode)
        .then(() => {
            setIsSuccess(true);
            setIsLoggingIn(false);
        })
        .catch(() => {
            setIsError(true);
            setIsLoggingIn(false);
        });
};

interface IProps {
    setLoginForm: Dispatch<loginForms>;
    providers: string[];
}

export function OtpTest({ setLoginForm, providers }: IProps) {
    const { translation } = useTypedTranslation();

    const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    return isSuccess ? (
        <MfaTestSuccess
            setIsSuccess={setIsSuccess}
            textSuccess={translation('MFA_VERIFICATION_SUCCESS_DESC_TEST')}
        />
    ) : (
        <TwoFactorOtp
            isMultipleProviders={providers.length > 1}
            setLoginForm={setLoginForm}
            isLoggingIn={isLoggingIn}
            onSubmit={onSubmitOtp(setIsLoggingIn, setIsSuccess)}
        />
    );
}
